import script from "./DeviceGroupAdd.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeviceGroupAdd.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__